export enum DepositType {
  TRUST = 'trust',
  ESCROW = 'escrow',
  CLIENT = 'client',
  CLIENT_CREDIT = 'client_credit',
  REFUND = 'refund',
  FIRM = 'firm'
}

export const DEPOSIT_TYPE_LABELS: Record<DepositType, string> = {
  [DepositType.TRUST]: 'Trust Deposit',
  [DepositType.ESCROW]: 'Escrow Deposit',
  [DepositType.CLIENT]: 'Client Payment',
  [DepositType.CLIENT_CREDIT]: 'Client Credit',
  [DepositType.REFUND]: 'Refund Payment',
  [DepositType.FIRM]: 'Firm Payment'
}
